import { message, Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import moment from 'moment';
import { operationalFunction } from 'components/UIBuilder/SectionFunction/Common';
import * as globalFunction from 'util/GlobalFunction';
import * as documentFunction from 'components/UIBuilder/SectionFunction/Document';

export function collapseAllGroups({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  let data = sectionComponent.child.current?.state.data.map((folder, i) => {
    folder.JobChecklistGroupList.map((group, i) => {
      group.Collapsed = true;
      return group;
    });
    return folder;
  });
  sectionComponent.child.current?.setState({ data });
}

export function collapseGroup({ component, key } = {}) {
  let data = component.state.data.map((folder, i) => {
    folder.JobChecklistGroupList.map((group, j) => {
      if (group.key === key) {
        if (group.Collapsed !== true) {
          group.Collapsed = true;
        } else {
          group.Collapsed = false;
        }
      }
      return group;
    });
    return folder;
  });
  component.setState({ data });
}

export function collapseFolder({ component, key, pageComponent } = {}) {
  let data = component.state.data.map((folder, i) => {
    if (folder.key === key) {
      if (folder.Collapsed !== true) {
        folder.Collapsed = true;
      } else {
        folder.Collapsed = false;
      }
      //写后台
      httpClient
        .put('Business/JobChecklistFolder/Collapse', { key: key, Collapsed: folder.Collapsed })
        .then(({ data }) => {
          if (data.result) {

          } else {
            globalFunction.handleResultError(data, pageComponent);
          }
        })
        .catch(function (error) {
          globalFunction.handleError(error, pageComponent);
        });
    }
    return folder;
  });
  component.setState({ data });
}

//上传File
export function uploadDocument({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  let documentComponent = globalFunction.getSectionComponent(pageComponent, 'Document');
  documentFunction.addBySection({ sectionComponent: documentComponent, pageComponent: pageComponent });
  pageComponent.setState({ uploadType: 'JobChecklistClientDocument', jobChecklistId: parameter.key });
  setTimeout(() => {
    documentComponent.child.current?.uploadDocument.current?.formRef.current?.setFieldValue('DocumentTypeId', 0);
  }, config.setTimeoutMilliSecond);
}

//删除File
export function deleteJobChecklistClientDocument({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  let that = this;
  httpClient
    .delete('Business/JobChecklist/DeleteJobChecklistClientDocument/' + parameter.key)
    .then(({ data }) => {
      if (data.result) {
        let newData = sectionComponent.child.current?.state.data.map(folder => {
          folder.JobChecklistGroupList.map(group => {
            group.JobChecklistList.map(jobChecklist => {
              if (jobChecklist.JobChecklistClientDocumentList !== null) {
                jobChecklist.JobChecklistClientDocumentList = jobChecklist.JobChecklistClientDocumentList.filter(item => item.key !== parameter.key);
              }
              return jobChecklist;
            })
            return group;
          })
          return folder;
        });

        setTimeout(() => {
          sectionComponent.child.current?.setState({ data: [] });
          sectionComponent.child.current?.setState({ data: newData });
        }, 10);
      } else {
        message.error(data.message);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

export function quickChangeClientStatus({ e, sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  let jobChecklistData = sectionComponent.child.current?.state.data.map((folder, i) => {
    folder.JobChecklistGroupList.map((group, j) => {
      group.JobChecklistList.map((jobChecklist, k) => {
        if (jobChecklist.key === parameter.key) {
          jobChecklist.Loading = true;
        }
        return jobChecklist;
      })
      return group;
    });
    return folder;
  });
  setTimeout(() => {
    sectionComponent.child.current?.setState({ data: [] });
    sectionComponent.child.current?.setState({ data: jobChecklistData });

    //写后台
    httpClient
      .put('Business/JobChecklist/QuickChangeClientStatus', { key: parameter.key })
      .then(({ data }) => {
        if (data.result) {
          // sectionComponent.getSectionDataByDefault();
          let jobChecklistData = sectionComponent.child.current?.state.data.map((folder, i) => {
            folder.JobChecklistGroupList.map((group, j) => {
              group.JobChecklistList.map((jobChecklist, k) => {
                if (jobChecklist.key === parameter.key) {
                  jobChecklist.ChecklistClientStatusId = data.data.ChecklistClientStatusId;
                  jobChecklist.ChecklistClientStatusName = data.data.ChecklistClientStatusName;
                  jobChecklist.ChecklistClientStatusBackgroundColor = data.data.ChecklistClientStatusBackgroundColor;
                  jobChecklist.Loading = false;
                }
                return jobChecklist;
              })
              return group;
            });
            return folder;
          });
          sectionComponent.child.current?.setState({ data: [] });
          sectionComponent.child.current?.setState({ data: jobChecklistData });
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }, config.setTimeoutMilliSecond);
  e.stopPropagation();
  return false;
}

//public编辑checklist
export function publicEditBySection({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  sectionComponent.setState({ dataLoading: true });
  sectionComponent.setState({ showModal: true, componentType: 'Edit' });
  pageComponent.setState({ selectedDocumentList: [] });

  setTimeout(() => {
    sectionComponent.customForm.current?.formRef.current?.setFieldsValue(parameter);
    sectionComponent.customForm.current?.setState({ formData: parameter, currentDataKey: parameter.key });
    sectionComponent.setState({ dataLoading: false });
  }, config.setTimeoutMilliSecond);
}

//public编辑checklist提交
export function customFormOnSubmit({ parameter, formComponent, sectionComponent, pageComponent, sectionName, uie } = {}) {

  let url = ''
  if (pageComponent.props?.accessCode == undefined) {
    url = 'Business/JobChecklist/'
  } else {
    url = 'Business/JobChecklist/PublicEdit'
  }

  let form = formComponent.formRef.current?.getFieldsValue();
  form.key = formComponent.state.currentDataKey;
  httpClient
    .put(url, form)
    .then(({ data }) => {
      if (data.result) {
        sectionComponent.setState({ customFormSubmitting: false });

        if (pageComponent.state.jobData.ModuleConfig.ClientPortalDelayNotify === true) {
          let requestReviewType = pageComponent.state.requestReviewType ? pageComponent.state.requestReviewType : [];
          requestReviewType.push(4);
          pageComponent.setState({ showNotifyChanges: true, requestReviewType });
        }

        setTimeout(() => {
          formComponent.resetFields();
          sectionComponent.setState({ showModal: false });
          setTimeout(() => {
            sectionComponent.getSectionDataByDefault();
            sectionComponent.setState({ componentType: null });
          }, config.setTimeoutMilliSecond);
        }, config.setTimeoutMilliSecond);
      } else {
        globalFunction.handleResultError(data);
        sectionComponent.setState({ customFormSubmitting: false });
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
      sectionComponent.setState({ customFormSubmitting: false });
    });
}

//public上传File
export function publicUploadDocument({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  let documentComponent = globalFunction.getSectionComponent(pageComponent, 'ReceivedDocument');
  documentFunction.addBySection({ sectionComponent: documentComponent, pageComponent: pageComponent });
  pageComponent.setState({ uploadType: 'JobChecklistClientDocument', jobChecklistId: parameter.key });
  setTimeout(() => {
    documentComponent.child.current?.uploadDocument.current?.formRef.current?.setFieldValue('DocumentTypeId', 0);
  }, config.setTimeoutMilliSecond);
}

//public修改Client状态
export function publicQuickChangeClientStatus({ e, sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  let jobChecklistData = sectionComponent.child.current?.state.data.map((folder, i) => {
    folder.JobChecklistGroupList.map((group, j) => {
      group.JobChecklistList.map((jobChecklist, k) => {
        if (jobChecklist.key === parameter.key) {
          jobChecklist.Loading = true;
        }
        return jobChecklist;
      })
      return group;
    });
    return folder;
  });
  setTimeout(() => {
    sectionComponent.child.current?.setState({ data: [] });
    sectionComponent.child.current?.setState({ data: jobChecklistData });

    //写后台
    httpClient
      .put('Business/JobChecklist/PublicQuickChangeClientStatus', { key: parameter.key })
      .then(({ data }) => {
        if (data.result) {
          // sectionComponent.getSectionDataByDefault();
          let jobChecklistData = sectionComponent.child.current?.state.data.map((folder, i) => {
            folder.JobChecklistGroupList.map((group, j) => {
              group.JobChecklistList.map((jobChecklist, k) => {
                if (jobChecklist.key === parameter.key) {
                  jobChecklist.ChecklistClientStatusId = data.data.ChecklistClientStatusId;
                  jobChecklist.ChecklistClientStatusName = data.data.ChecklistClientStatusName;
                  jobChecklist.ChecklistClientStatusBackgroundColor = data.data.ChecklistClientStatusBackgroundColor;
                  jobChecklist.Loading = false;
                }
                return jobChecklist;
              })
              return group;
            });
            return folder;
          });
          sectionComponent.child.current?.setState({ data: [] });
          sectionComponent.child.current?.setState({ data: jobChecklistData });
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }, config.setTimeoutMilliSecond);
  e.stopPropagation();
  return false;
}

//public删除File
export function deletePublicJobChecklistClientDocument({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  let that = this;
  httpClient
    .delete('Business/JobChecklist/DeletePublicJobChecklistClientDocument/' + parameter.key + '?accessCode=' + pageComponent.state.accessCode)
    .then(({ data }) => {
      if (data.result) {
        sectionComponent.getSectionDataByDefault();
      } else {
        message.error(data.message);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

export function docMergeRFI({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  if (pageComponent.props?.accessCode === undefined) {
    globalFunction.download({ url: '/Admin/MailMergeTemplate/DownloadPdf?parameterId=' + uie.data + '&objId=' + parameter.key + '&dataModelType=1&keyword=RFI', data: null, filename: 'RFI.pdf' })
  } else {
    globalFunction.download({ url: '/Admin/MailMergeTemplate/PublicDownloadPdf?parameterId=' + uie.data + '&accessCode=' + pageComponent.props?.accessCode + '&dataModelType=1&keyword=RFI', data: null, filename: 'RFI.pdf' })
  }
}
